package app.components

import app.api.ProjectStepApi
import app.api.ProjectStepApi.StepUpdate
import app.model.RunCondition
import dev.fritz2.core.*

fun RenderContext.runConditionInput(
    stepIndex: Int,
    stepRunCondition: RunCondition,
    projectStepApi: ProjectStepApi
) {
    div {
        p("text-sm dark:text-gray-0") { +"Run Condition:" }
        div("flex gap-2") {
            select("h-8 w-64 bg-white dark:bg-gray-800 dark:border-gray-600 dark:text-white") {
                RunCondition.entries.forEach { condition ->
                    option {
                        val conditionName = when (condition) {
                            is RunCondition.Success -> "SUCCESS"
                            is RunCondition.AlwaysRun -> "ALWAYS_RUN"
                            else -> error("Unexpected RunCondition")
                        }
                        value(conditionName)
                        +conditionName
                        if (RunCondition.getType(stepRunCondition) == conditionName) {
                            selected(true)
                        }
                    }
                }
                changes.values() handledBy { conditionName: String ->
                    val condition = when (conditionName) {
                        "SUCCESS" -> RunCondition.Success
                        "ALWAYS_RUN" -> RunCondition.AlwaysRun
                        else -> throw IllegalStateException("Missing Type here")
                    }
                    projectStepApi.updateStep(
                        Pair(
                            stepIndex,
                            StepUpdate.RunCondition(condition)
                        )
                    )
                }
            }
        }
    }
}
